import { useEffect } from "react";
import { DEFAULT_SEO, SITE_URL } from "@/lib/seo";
import {
  COMPANY_ADDRESS_LINE,
  COMPANY_BRAND_NAME,
  COMPANY_CIF,
  COMPANY_CITY,
  COMPANY_CONTACT_EMAIL,
  COMPANY_LEGAL_NAME,
  COMPANY_POSTAL_CODE,
} from "@/lib/company";

const JSON_LD_ID = "taxby-jsonld";

const JsonLd = () => {
  useEffect(() => {
    const data = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": `${SITE_URL}/#organization`,
          name: COMPANY_BRAND_NAME,
          legalName: COMPANY_LEGAL_NAME,
          taxID: COMPANY_CIF,
          url: SITE_URL,
          email: COMPANY_CONTACT_EMAIL,
          address: {
            "@type": "PostalAddress",
            streetAddress: COMPANY_ADDRESS_LINE,
            postalCode: COMPANY_POSTAL_CODE,
            addressLocality: COMPANY_CITY,
            addressCountry: "ES",
          },
        },
        {
          "@type": "WebSite",
          "@id": `${SITE_URL}/#website`,
          url: SITE_URL,
          name: COMPANY_BRAND_NAME,
          description: DEFAULT_SEO.description,
          publisher: { "@id": `${SITE_URL}/#organization` },
          inLanguage: "es-ES",
        },
      ],
    };

    let script = document.getElementById(JSON_LD_ID) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement("script");
      script.id = JSON_LD_ID;
      script.type = "application/ld+json";
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(data);

    return () => {
      script?.remove();
    };
  }, []);

  return null;
};

export default JsonLd;
